import {Button, Card, Col, Container, Form, ListGroup, Row, Table} from "react-bootstrap";
import {useEffect, useState} from "react";
import {addJobNotes, getJobNotes} from "../service/jobService";


export default function JobExpand({job, jobNoteList, refreshJobNotesList}) {

    const [newJobNote, setNewJobNote] = useState("")


    function handleAddNewJobNoteSubmit(e) {
        e.preventDefault();
        addJobNotes(job.cos_job_id, newJobNote).then(response => {
            if (response.status === 201) {
                setNewJobNote("")
                refreshJobNotesList(job.cos_job_id);

            }
        })

    }


    return (<div>
        <b>Job Notes:</b>
        {jobNoteList ? jobNoteList.map((jobnote, idx) => (
            <ListGroup.Item
                key={idx}>{jobnote.note} by {jobnote.createdby} on {new Date(jobnote.timestamp).toLocaleString()}</ListGroup.Item>
        )) : ''}

        <Form onSubmit={handleAddNewJobNoteSubmit}>


            <Form.Group className="mb-3" controlId="jobnote" style={{width: "100%"}}>
                <Form.Control type="text"
                              value={newJobNote}
                              required
                              onChange={(e) => setNewJobNote(e.target.value)}
                              placeholder="Add New Job Note"/>
            </Form.Group>

            <Button variant="outline-secondary" type="submit" className="mb-3" size={"sm"}
                    disabled={newJobNote.length <= 0}
                    style={{width: "100%"}}>
                Add Job Note
            </Button>


        </Form>


    </div>)

}
